import React from "react";

import { connect } from 'react-redux';
import { withRouter } from "react-router-dom";
import classnames from "classnames";
import {
  registrationFieldUpdate,
  contractInfoFieldValidate,
  contractSubmit,
} from "redux/ducks/Registration";
import InputOrFlatpickr from 'components/InputOrFlatpickr';

const ContractInfo = ({
  history,
  updateField,
  user,
  validateField,
  validation,
  contractSubmit,
}) => {

  const onFieldValidate = field => {
    validateField(field);
  };

  const onPrevious = e => {
    e.preventDefault();
    history.push("/sign-up/post-event/profile");
  };

  const onNext = e => {
    e.preventDefault();
    history.push("/sign-up/post-event/contact")
  };

  const onDateChange = (field, triggerValidate) => {
    return (value) => {
      updateField(field, value);
      if (triggerValidate) {
        onFieldValidate(field);
      }
    };
  };

  const onFieldChange = (field, triggerValidate) => {
    return (ev: SyntheticInputEvent<HTMLInputElement>) => {
      updateField(field, ev.currentTarget.value);
      if (triggerValidate) {
        onFieldValidate(field);
      }
    };
  };

  return (
    <div className="postEvent">
      <h2>Next, let's get a few job parameters:</h2>
      <form id="accountForm" noValidate>
        <div className="form-group">
          <label className="required" htmlFor="startDate">Start Date</label>
          <InputOrFlatpickr
            type="text"
            name="startTime"
            options={dateTimePickerOptions}
            value={user.startDate}
            onChange={onDateChange('startDate', true)}
            onBlur={() => { onFieldValidate("startDate"); onFieldValidate("profession"); }}
            className={classnames("form-control date-picker", {
              "is-invalid": validation.errors.startDate,
            })}
            placeholder="Pick start date"
          />
          <div className="invalid-feedback">{validation.errors.startDate}</div>
        </div>
        <div className="form-group">
          <label className="required" htmlFor="endDate">End Date</label>
          <InputOrFlatpickr
            type="text"
            name="endDate"
            options={dateTimePickerOptions}
            value={user.endDate}
            onChange={onDateChange('endDate', true)}
            onBlur={onFieldValidate.bind(this, "endDate")}
            className={classnames("form-control date-picker", {
              "is-invalid": validation.errors.endDate,
            })}
            placeholder="Pick end date"
          />
          <div className="invalid-feedback">{validation.errors.endDate}</div>
        </div>
        <div className="actions">
          <button
            type="submit"
            className="btn btn-primary bold-button"
            onClick={onPrevious}
          >
            Previous
          </button>
          <button
            type="submit"
            className="btn btn-danger bold-button"
            disabled={!validation.valid}
            onClick={onNext}
          >
            Next
          </button>
        </div>
      </form>
    </div>
  );
};

const dateTimePickerOptions = {
  enableTime: false,
  dateFormat: "m/d/y",
};

function mapStateToProps(state) {
  return {
    user: state.registration.user,
    validation: state.registration.contractInfoValidation,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    updateField: (field, value) =>
      dispatch(registrationFieldUpdate(field, value)),
    validateField: field => dispatch(contractInfoFieldValidate(field)),
    contractSubmit: history => dispatch(contractSubmit(history)),
  };
}

export { ContractInfo };

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ContractInfo))
